// src/firebaseConfig.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { offlineRuntimeEnabled } from './offline/config';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDJ8HyRAm7z0RlgmYy3EjubVujy7E3ZBfA",
  authDomain: "drwaiting-30f56.firebaseapp.com",
  projectId: "drwaiting-30f56",
  storageBucket: "drwaiting-30f56.firebasestorage.app",
  messagingSenderId: "937005545176",
  appId: "1:937005545176:web:be56ec33fce7e64e9f49ad",
  measurementId: "G-34TTB75D9R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// Only pilot builds enable disk persistence. A failed setup must never silently
// claim that an offline action is durable in an in-memory cache.
export const offlinePersistenceReady = offlineRuntimeEnabled
  ? enableMultiTabIndexedDbPersistence(db).then(() => true, () => false)
  : Promise.resolve(false);
export const storage = getStorage(app);
